import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';

const BUILDER_CATEGORY = { reroof: 'Re-Roof', painting: 'Re-Coat', guttering: 'Guttering', maintenance: 'Maintenance', repairs: 'Repairs' };
const ORDER = ['Repairs', 'Re-Coat', 'Re-Roof', 'Restoration', 'Remedial Repairs', 'Guttering', 'Maintenance', 'New Roof', 'Supply', 'Appraisal'];

// One Quotation Type picker (same source + labels everywhere). Saves via PATCH unless `onPick` (controlled) is given.
export function QuotationTypeSelect({ api, quoteId, builder, roofType, current, onSaved, onPick, disabled = false, testId = 'draft-gate-qt' }) {
  const [items, setItems] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [value, setValue] = useState(current || '');
  useEffect(() => { setValue(current || ''); }, [current]);
  useEffect(() => {
    const params = showAll ? {} : { roof_type: roofType || '', category: BUILDER_CATEGORY[builder] || '' };
    api.get('/quote-types-catalog', { params }).then(r => setItems(r.data?.items || [])).catch(() => setItems([]));
  }, [api, showAll, roofType, builder]);
  const pick = async (ref) => {
    setValue(ref);
    if (onPick) { onPick(ref); return; }
    try { await api.patch(`/appraisals/${quoteId}`, { quotation_type: ref }); toast.success(`Quotation Type: ${ref}`); onSaved && onSaved(ref); }
    catch (e) { setValue(current || ''); toast.error(e?.response?.data?.detail || 'Could not save Quotation Type'); }
  };
  const groups = {};
  items.forEach(i => { const c = (i.quote_categories || [])[0] || 'Other'; (groups[c] = groups[c] || []).push(i.ref); });
  const cats = Object.keys(groups).sort((a, b) => (ORDER.indexOf(a) + 1 || 99) - (ORDER.indexOf(b) + 1 || 99));
  const refs = items.map(i => i.ref);
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testId}>
      <span className="text-xs font-semibold text-slate-700">Quotation Type</span>
      <select value={value} onChange={(e) => pick(e.target.value)} disabled={disabled} data-testid={`${testId}-select`}
        className={`text-sm border rounded px-2 py-1 bg-white min-w-[260px] disabled:bg-slate-100 disabled:text-slate-500 ${value ? 'border-slate-300' : 'border-amber-400 ring-1 ring-amber-300'}`}>
        <option value="" disabled>— Pick a Quotation Type —</option>
        {value && !refs.includes(value) && <option value={value}>{value}</option>}
        {cats.map(c => (
          <optgroup key={c} label={c}>
            {groups[c].map(r => <option key={r} value={r}>{r}</option>)}
          </optgroup>
        ))}
      </select>
      <label className="text-xs text-slate-600 inline-flex items-center gap-1 cursor-pointer">
        <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} disabled={disabled} data-testid={`${testId}-show-all`} />
        Show all types
      </label>
    </div>
  );
}
